function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 4,
  width: 117,
  height: 117,
  rx: 8,
  strokeWidth: 8
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M96.636 41.8178H37.4837L48.5598 30.7416C49.8734 29.4282 49.8734 27.2983 48.5598 25.9847C47.2464 24.6711 45.1165 24.6711 43.8029 25.9847L26.9847 42.8029C25.6711 44.1163 25.6711 46.2461 26.9847 47.5598L43.8029 64.3779C44.4597 65.0347 45.3206 65.3633 46.1814 65.3633C47.0423 65.3633 47.9032 65.0347 48.5598 64.3779C49.8734 63.0646 49.8734 60.9347 48.5598 59.6211L37.4837 48.5451H96.636C98.4936 48.5451 99.9996 47.0391 99.9996 45.1814C99.9996 43.3238 98.4936 41.8178 96.636 41.8178Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.1965 59.6215C80.8831 58.3081 78.7533 58.3081 77.4396 59.6215C76.126 60.9349 76.126 63.0648 77.4396 64.3784L88.5159 75.4546H29.3636C27.506 75.4546 26 76.9606 26 78.8182C26 80.6759 27.506 82.1819 29.3636 82.1819H88.5159L77.4399 93.2581C76.1263 94.5715 76.1263 96.7013 77.4399 98.0149C78.0965 98.6715 78.9573 99 79.8182 99C80.6791 99 81.5399 98.6715 82.1965 98.0147L99.0147 81.1965C100.328 79.8832 100.328 77.7533 99.0147 76.4397L82.1965 59.6215Z"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 74,
  height: 74,
  transform: "translate(26 25)"
})));

function SvgReplace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplace);
export default __webpack_public_path__ + "static/media/replace.19b2a5aa.svg";
export { ForwardRef as ReactComponent };